import React from 'react'

import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button'
import { Container, Image } from 'components/qstrap'

const Header = () => (
  <div className="kit-header">
    <Container>
      <div className="kit-header__content">
        <Image src="/assets/img/kit-landing/logo/kit-logo-quipper-campus.png" alt="Kirirom Institute of Technology logo | Quipper Campus"/>
        <Typography component="h1" variant="big">
          The First Silicon <br/>
          Valley Institute<br/>
          in ASEAN
        </Typography>
        <Button
          component="a"
          href="https://goo.gl/4uGSY2"
          target="_blank"
          rel="noopener norefferer"
          className="btn-large"
        >
          Daftar Sekarang
        </Button>
      </div>
    </Container>
  </div>
)

export default Header
